export default /^[0-9]+$/;
